import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { div } from '../../helpers/components';
import { theme } from '../../styles';

export const Title = styled.div<{ $fontSize?: string }>`
  font-weight: 500;
  text-transform: uppercase;
  font-size: ${({ $fontSize }: { $fontSize?: string }) => $fontSize ?? '0.8rem'};
  margin-bottom: 0.3rem;
  color: ${darken(0.1, theme.gray500)};
  [data-theme='dark'] & {
    color: #8a9bc2;
  }
`;

export const InfoTitle = styled.div<{
  $fontSize?: string;
  $fontWeight?: string;
}>`
  text-transform: uppercase;
  font-size: ${({ $fontSize }: { $fontSize?: string }) => $fontSize ?? '0.8rem'};
  font-weight: ${({ $fontWeight }: { $fontWeight?: string }) => $fontWeight ?? '500'};
  color: ${darken(0.1, theme.gray500)};
  [data-theme='dark'] & {
    color: #8a9bc2;
  }
`;

/**
 * Data value display. Uses color:inherit so it adapts to the MUI theme's
 * text.primary in both light and dark mode (no hardcoded color).
 */
export const Data = div({
  fontSize: '1.2rem',
  color: 'inherit',
});

interface Props {
  readonly title: React.ReactNode;
  readonly data: React.ReactNode | (() => React.ReactNode);
  readonly fontSize?: string;
}

export const Info = (p: Props) => (
  <React.Fragment>
    <Title $fontSize={p.fontSize}>{p.title}</Title>
    {p.data instanceof Function ? p.data() : <Data>{p.data}</Data>}
  </React.Fragment>
);
